const state = {
    validationErrors: {},
    serverError: '',
    notFoundError: '',
    connectionError: '',
    statusCode: ''
}

const getters = {
    validationErrors: state => {  return state.validationErrors; },
    serverError: state=> {return state.serverError;},
    notFoundError: state=> { return state.notFoundError;},
    statusCode: state=> { return state.statusCode; },
    connectionError: state=> {return state.connectionError }
}

const actions = {
    clearErrors({commit}) {
        commit('clearErrors');
    },
    setErrors({commit},error) { 
        commit('setErrors', error);
    }
}

const mutations = {
    clearErrors(state) {
        state.validationErrors = {};
        state.serverError = '';
        state.notFoundError = '';
        state.statusCode = '';
        state.noConnection = '';
    },
    setErrors (state, payload) {
        if(payload == undefined) return;

        var response = payload.response;

        if(response != undefined) 
        { 
            state.statusCode = response.status;
            
            if(state.statusCode == 400 && response.data.errors) 
            {
                state.validationErrors = response.data.errors; 
            }

            if(state.statusCode == 404) 
            {
                state.notFoundError = 'Oeps, de data kon niet worden gevonden!';
            }

            if(state.statusCode == 500) 
            {
                state.serverError = `${response.data.message ? response.data.message : "Er is een onbekende fout opgetreden"}`;
            }
        }
        else
        {
            if(payload.toString().includes('Network Error')) {
                state.connectionError = 'Oeps, er is een verbindingsfout opgetreden!';
            }
            else if(process.env.NODE_ENV !== 'production') {
                state.connectionError = payload.toString();
            }
            else {
                state.connectionError = 'Oeps, er is een applicatiefout opgetreden!';
            }
        }

        if(process.env.NODE_ENV !== 'production') {
            // eslint-disable-next-line no-console
            console.log(payload); 
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}